<!--The content below is only a placeholder and can be replaced.-->
<div class="app_container">
  <router-outlet></router-outlet>
</div>

